<template>
  <section>
    <div class="user-main">
      <div class="utab clearfix">
        <ul class="clearlist clearfix fl">
          <li :class="status==''?'active':''" @click="changeTab('')">
            <a href="javascript:;">所有商品</a>
          </li>
          <li :class="status=='0'?'active':''" @click="changeTab('0')">
            <a href="javascript:;">待导入</a>
          </li>
          <li :class="status==1?'active':''" @click="changeTab('1')">
            <a href="javascript:;">已导入</a>
          </li>
          <li :class="status==2?'active':''" @click="changeTab('2')">
            <a href="javascript:;">失败</a>
          </li>
        </ul>
      </div>
      <div class="user-cont layui-card">
        <div class="upload flex ju-be">
          <span class="title">批量询价</span>
          <div class="uploadbtn center">
            <el-upload
              class="iconfont icon-refresh color-primary"
              :on-success="handleAvatarSuccess"
              :action="uploadimg"
            >点击上传</el-upload>
            <button type="primary" class>
              <a class="iconfont icon-share03" href="https://www.quilimen.com/static/admin/order.xls">
                <span>模板下载</span>
              </a>
            </button>
          </div>
        </div>
        <div class="layui-card-body">
          <div class="pingtai flex">
            <div class="wire"></div>
            <span>平台商品</span>
          </div>
          <div class="cartcontent">
            <el-table
              border
              ref="multipleTable"
              :data="list1.shoplist[1].items"
              tooltip-effect="dark"
              style="width: 100%"
              class="maxheight"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="sn" label="编码"></el-table-column>
              <el-table-column prop="title" label="商品名字" width="300"></el-table-column>
              <el-table-column prop="num" label="数量"></el-table-column>
              <el-table-column prop="price" label="单价"></el-table-column>
              <el-table-column prop="unit" label="单位"></el-table-column>
              <el-table-column prop="name" label="小计">
                <template slot-scope="scope">
                  <span>{{(scope.row.num*scope.row.price).toFixed(2)}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="amount3" label="操作">
                <template slot-scope="scope" v-if="scope==0">
                  <el-button type="danger" size="small" @click="deleteorder(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="totalnum flex ju-be">
            <span class="goodsnum">
              共{{multipleSelection.length}}件商品
              <el-button type="danger" size="small" @click="deleteorder('multipleSelection')">删除选择商品</el-button>
            </span>
            <div class="submit">
              <span>合计</span>
              <span class="color-primary">￥{{caigoumoney}}</span>
              <button type="primary" @click="addCaigou('multipleSelection')">提交采购单</button>
            </div>
          </div>
        </div>
        <div class="layui-card-body">
          <div class="pingtai flex">
            <div class="wire"></div>
            <span>询价商品</span>
            <span
              class="color-primary"
              style="margin-left:10px;font-weight:400"
            >温馨提示：平台需要1-2个工作日确定价格，待平台确认后，自动生成采购单</span>
          </div>
          <div class="cartcontent">
            <el-table
              border
              ref="multipleTable"
              :data="list2.shoplist[1].items"
              tooltip-effect="dark"
              style="width: 100%"
              class="maxheight"
              @selection-change="handleSelectionChangexj"
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="sn" label="编码"></el-table-column>
              <el-table-column prop="title" label="商品名字" width="300"></el-table-column>
              <el-table-column prop="num" label="数量"></el-table-column>

              <el-table-column prop="amount3" label="操作">
                <template slot-scope="scope">
                  <el-button type="danger" size="small" @click="deleteorder(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="totalnum flex ju-be">
            <span class="goodsnum">
              共{{multipleSelectionxj.length}}件商品
              <el-button
                type="danger"
                size="small"
                @click="deleteorder('multipleSelectionxj')"
              >删除选择商品</el-button>
            </span>
            <div class="submit">
              <!-- <span>合计</span>
              <span class="color-primary">￥{{caigoumoneyxj}}</span>-->
              <button type="primary" @click="addCaigou('multipleSelectionxj')">提交询价单</button>
            </div>
          </div>
          <!-- <div id="fenye">
            <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
          </div>-->
        </div>
      </div>
    </div>
    <el-dialog title="收货地址" :modal="false" :visible.sync="addressDialogVisible" width="50%" center>
      <Address @watchaddress="setadreid"></Address>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addressDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitorder">提交订单</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import Address from '../components/address';
export default {
  components: { Address },
  name: 'Order',
  data() {
    return {
      checked: false,
      status: '0',
      remark: '',
      addressDialogVisible: false,
      districtid: '',
      addressid: '',

      list1: { shoplist: { 1: { items: [] } } },
      list2: { shoplist: { 1: { items: [] } } },
      uploadimg: sessionStorage.baseUrl + 'app/file/upload',
      typearr: '',
      multipleSelection: [],
      multipleSelectionxj: [],
      caigoumoney: '',
      caigoumoneyxj: '',
      successurl: '/static/uploadfile/file/2019-09-28/5d8f2af3c0782.xls'
    };
  },
  watch: {
    multipleSelection() {
      let multipleSelection = this.multipleSelection;
      let caigoumoney = 0;
      for (let i = 0; i < multipleSelection.length; i++) {
        caigoumoney =
          caigoumoney + multipleSelection[i].num * multipleSelection[i].price;
      }
      this.caigoumoney = caigoumoney.toFixed(2);
    },
    multipleSelectionxj() {
      let multipleSelectionxj = this.multipleSelectionxj;
      let caigoumoneyxj = 0;
      for (let i = 0; i < multipleSelectionxj.length; i++) {
        caigoumoneyxj =
          caigoumoneyxj +
          multipleSelectionxj[i].num * multipleSelectionxj[i].price;
      }
      this.caigoumoneyxj = caigoumoneyxj.toFixed(2);
    }
  },
  props: {},
  methods: {
    changeTab(e) {
      this.status = e;
      console.log('this.status', this.status);
      this.getOrderList();
    },
    async addCaigou(type) {
      //打开弹框
      if (this[type].length == 0) {
        this.$message.error('请勾选商品');
        return;
      }
      this.typearr = type;
      this.addressDialogVisible = true;
    },
    async submitorder() {
      //提交采购订单
      if (!this.addressid) {
        this.$message.error('请选择收货地址');
        return;
      }
      let ids = this[this.typearr].map(item => {
        return item.id;
      });
      ids = ids.join(',');
      let res = await this.$fetch('order/createorderbatch', {
        body: {
          addressid: this.addressid,
          paymethod: 1,
          remark: this.remark,
          ids
        }
      });
      if (res) {
        this.$message.success('提交成功');
        this.addressDialogVisible = false;
        this.getOrderList();
      }
    },
    setadreid(item) {
      this.districtid = item.districtid;
      this.addressid = item.addressid;
    },
    async deleteorder(row) {
      console.log(row);
      let ids = '';
      if (!row.id) {
        if (this[row].length == 0) {
          this.$message.error('请勾选商品');
          return;
        }
        ids = this[row].map(item => {
          return item.id;
        });
        ids = ids.join(',');
      } else {
        ids = row.id;
      }
      let res = await this.$fetch('order/deleteimport', {
        body: { ids }
      });
      if (res || res == 0) {
        this.$message.success('删除成功');
        this.getOrderList();
      }
    },
    async getOrderList() {
      let { list1, list2 } = await this.$fetch('order/batchlist', {
        body: { status: this.status }
      });

      if (JSON.stringify(list1.shoplist) == '[]') {
        this.list1 = { shoplist: { 1: { items: [] } } };
      } else {
        this.list1 = list1;
      }
      if (JSON.stringify(list2.shoplist) == '[]') {
        this.list2 = { shoplist: { 1: { items: [] } } };
      } else {
        this.list2 = list2;
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSelectionChangexj(val) {
      this.multipleSelectionxj = val;
    },
    async handleAvatarSuccess(res, file) {
      if (res.code == 0) {
        this.successurl = res.msg;
        this.$message.success('上传成功,正在生成商品列表');
        let { list1, list2 } = await this.$fetch('order/fileimport', {
          body: {
            xlsfile: this.successurl
          }
        });
        // console.log("caigouListcaigouList", caigouList);
        if (JSON.stringify(list1.shoplist) == '[]') {
          this.list1 = { shoplist: { 1: { items: [] } } };
        } else {
          this.list1 = list1;
        }
        if (JSON.stringify(list2.shoplist) == '[]') {
          // alert(1)
          this.list2 = { shoplist: { 1: { items: [] } } };
        } else {
          this.list2 = list2;
        }
      } else {
        this.$message.error('上传失败，请稍后重试');
      }
    }
  },
  async mounted() {
    this.getOrderList();
  }
};
</script>

<style lang='scss' scoped>
.color-primary {
  .is-checked {
    .el-checkbox__inner {
      background: #f19d15 !important;
      border-color: #f19d15;
    }
  }
  .el-checkbox__inner {
    border-color: #f19d15 !important;
  }
}
.totalnum {
  width: 100%;
  height: 70px;
  background: rgba(245, 245, 245, 1);
  padding: 0 30px;
  box-sizing: border-box;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  margin-top: 20px;
  .submit {
    button {
      height: 40px;
      width: 110px;
      font-size: 12px;
    }
  }
}
.maxheight {
  max-height: 500px;
  overflow-y: auto;
}
.upload {
  // padding: 20px;
  padding-right: 20px;
  box-sizing: border-box;
  .uploadbtn {
    button {
      width: 100px;
      font-size: 12px;
      height: 30px;
      span {
        margin-left: 5px;
      }
      a:hover {
        color: #fff;
      }
    }
  }
  .icon-refresh {
    font-size: 12px;
    margin-right: 12px;
    cursor: pointer;
  }
}
.pingtai {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(102, 102, 102, 1);
  .wire {
    width: 4px;
    height: 14px;
    background: rgba(241, 157, 21, 1);
    margin-right: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/batchOrder.vue